// AI GENERATED
export const FILEROOMS_EN = {
  myFiles: 'My Files',
  sharedWithMe: 'Shared with me',
  newFolder: 'New Folder',
  folderEmpty: 'This folder is empty',
  errorStatus: 'error',
  menuRename: 'Rename',
  menuDownload: 'Download',
  menuPreview: 'Preview',
  previewUnavailable: 'Preview not available',
  previewTruncated: 'Preview truncated — download the file to see everything.',
  menuShare: 'Share',
  menuShareFile: 'Share',
  menuMove: 'Move to...',
  menuDelete: 'Delete',
  uploading: 'Uploading...',
  dropFilesOrBrowse: 'Drop files here or click to browse',
  newFolderDescription: 'Enter a name for the new folder.',
  folderNamePlaceholder: 'Folder name',
  renameTitle: 'Rename',
  renameDescription: 'Enter a new name.',
  namePlaceholder: 'Name',
  rename: 'Rename',
  moveTitle: 'Move "{name}"',
  noFoldersHere: 'No folders here',
  moveHere: 'Move here',
  shareTitle: 'Share "{name}"',
  shareDescription: 'Grant access to an organisation member.',
  selectMember: 'Select a member...',
  searchMembers: 'Search members...',
  noMembersFound: 'No members found.',
  permissionRead: 'Read',
  permissionAdd: 'Write',
  noGrantsYet: 'No grants yet',
  userNotFound: 'User not found in your organisation',
  inheritedFrom: 'Inherited from "{name}"',
  inheritedGrants: 'Inherited access',
  emailInbox: 'Email Inbox',
  inboxNamePlaceholder: 'Inbox name (max 16)',
  createInbox: 'Create Inbox',
  menuManageInbox: 'Manage Inbox',
  myInboxes: 'My Inboxes',
  emailCopied: 'Email address copied',
  createFolderFailed: 'Could not create folder',
  uploadFailed: 'Could not upload file',
  deleteFailed: 'Could not delete item',
  updateFailed: 'Could not update item',
  inboxCreateFailed: 'Could not create inbox',
  inboxDeleteFailed: 'Could not delete inbox',
  revokeFailed: 'Could not revoke access'
}

// AI GENERATED
export const FILEROOMS_DE = {
  myFiles: 'Meine Dateien',
  sharedWithMe: 'Mit mir geteilt',
  newFolder: 'Neuer Ordner',
  folderEmpty: 'Dieser Ordner ist leer',
  errorStatus: 'Fehler',
  menuRename: 'Umbenennen',
  menuDownload: 'Herunterladen',
  menuPreview: 'Vorschau',
  previewUnavailable: 'Vorschau nicht verfügbar',
  previewTruncated: 'Vorschau gekürzt — laden Sie die Datei herunter, um alles zu sehen.',
  menuShare: 'Teilen',
  menuShareFile: 'Teilen',
  menuMove: 'Verschieben nach...',
  menuDelete: 'Löschen',
  uploading: 'Wird hochgeladen...',
  dropFilesOrBrowse: 'Dateien hier ablegen oder klicken zum Durchsuchen',
  newFolderDescription: 'Geben Sie einen Namen für den neuen Ordner ein.',
  folderNamePlaceholder: 'Ordnername',
  renameTitle: 'Umbenennen',
  renameDescription: 'Geben Sie einen neuen Namen ein.',
  namePlaceholder: 'Name',
  rename: 'Umbenennen',
  moveTitle: '"{name}" verschieben',
  noFoldersHere: 'Keine Ordner hier',
  moveHere: 'Hierher verschieben',
  shareTitle: '"{name}" teilen',
  shareDescription: 'Einem Organisationsmitglied Zugriff gewähren.',
  selectMember: 'Mitglied auswählen...',
  searchMembers: 'Mitglieder suchen...',
  noMembersFound: 'Keine Mitglieder gefunden.',
  permissionRead: 'Lesen',
  permissionAdd: 'Schreiben',
  noGrantsYet: 'Noch keine Freigaben',
  userNotFound: 'Benutzer nicht in Ihrer Organisation gefunden',
  inheritedFrom: 'Geerbt von "{name}"',
  inheritedGrants: 'Geerbter Zugriff',
  emailInbox: 'E-Mail-Posteingang',
  inboxNamePlaceholder: 'Posteingangsname (max. 16)',
  createInbox: 'Posteingang erstellen',
  menuManageInbox: 'Posteingang verwalten',
  myInboxes: 'Meine Posteingänge',
  emailCopied: 'E-Mail-Adresse kopiert',
  createFolderFailed: 'Ordner konnte nicht erstellt werden',
  uploadFailed: 'Datei konnte nicht hochgeladen werden',
  deleteFailed: 'Element konnte nicht gelöscht werden',
  updateFailed: 'Element konnte nicht aktualisiert werden',
  inboxCreateFailed: 'Posteingang konnte nicht erstellt werden',
  inboxDeleteFailed: 'Posteingang konnte nicht gelöscht werden',
  revokeFailed: 'Zugriff konnte nicht entzogen werden'
}
